// extracted by mini-css-extract-plugin
module.exports = {"items":"Team_items__1Zeln"};